module.exports = __webpack_public_path__ + "fonts/iconfont.0bab66d3.woff";